import Masonry from 'masonry-layout'

import { BB } from '@utils/utils'
import BaseComponent from './_BaseComponent'




/* Wall
----------------------------------------------------------------------------------------------------*/

export default class Wall extends BaseComponent {

    constructor($el, namespace) {
        super('Wall', $el, namespace)


        this.on()
    }

    bindProperties() {
        this.throttleRelayout = false

        this.setSizes()
        this.buildWall()
    }


    bindHandlers() {
        this.resizeHandler = () => { this.onResize() }
    }


    bindEvents() {
        this.addListeners(
            [document, 'layoutChange', this.resizeHandler],
        )
    }


    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        this.setSizes()
    }




    /* Actions
    --------------------------------------------------------- */

    setSizes() {
        const { isMobile, gutWidth } = APP.Layout

        const margin = isMobile ? '' : `${gutWidth}px`

        this.$refs.brick.css('margin-bottom', margin)

        if (this.wall && this.throttleRelayout) {
            this.wall.layout()
        }
    }


    buildWall() {
        const originLeft      = !this.$el[0].hasAttribute('data-wall-reversed')

        this.wall = new Masonry(this.$refs.inner[0], {
            originLeft,
            resize             : !this.throttleRelayout,
            transitionDuration : 0,
            itemSelector       : '.js-Wall-brick',
            columnWidth        : '.js-Wall-col',
            gutter             : '.js-Wall-gut',
        })

        this.wall.on('layoutComplete', () => {
            this.detectEdges()
            this.$utils.doc.trigger('contentChange')
        })

        setTimeout(() => {
            this.wall.layout()
        }, 100)
    }




    /* Values
    --------------------------------------------------------- */

    detectEdges() {
        const { offsetWidth: width } = this.$refs.inner[0]

        this.wall.items.forEach(({ position, size, element }) => {
            const isLeft = position.x === 0
            const isRight = width - position.x - size.width <= 10

            element.classList.toggle('is-right', isRight)
            element.classList.toggle('is-left', isLeft)
        })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



